import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "Introduction", "id": "about" },
    { "name": "Courses Offered", "id": "courses" },
    { "name": "Faculty Members", "id": "faculty" },
    { "name": "Timetable", "id": "timetable" },
    { "name": "Facilities", "id": "facilities" },
    { "name": "Seminars/Conferences/Workshops", "id": "events" },
    { "name": "Research Scholars", "id": "researchScholars" },
    { "name": "Achievements", "id": "achievements" },
    { "name": "Contact", "id": "contact" }
];

const departmentContent = {
    "about": (
        <div>
            <p className="mb-2 text-justify">Yoga is not merely a physical exercise but a profound science and lifestyle that teaches the art of balancing and harmonizing the body, mind, and spirit. It has been an integral part of India's rich and diverse knowledge traditions, such as Vedic, Buddhist, Jain, etc., whose roots are thousands of years old.</p>
            <p className="mb-2 text-justify">Today, science also acknowledges the importance of Yoga, and modern medical research has proven that Yoga is helpful in treating various mental and physical ailments. However, due to the prevalence of this health-centric aspect of Yoga among the common people, its widespread acceptance has remained very limited.</p>
            <p className="mb-2 text-justify">In the words of Sri Aurobindo – "Yoga means not merely the attainment of God but such a complete surrender and transformation of the inner and outer life that through it the Divine Consciousness may be manifested and it may itself be a part of the Divine work" – in these terms, it is necessary to view Yoga not merely as a system of exercise and health but as a complete philosophy of life.</p>
            <p className="mb-2 text-justify">Maharshi Valmiki Sanskrit University, Kaithal, is a prestigious institution dedicated to the preservation and promotion of Indian culture, Sanskrit language, and knowledge traditions. It was established in 2018 in furtherance of the Haryana Government's plan to establish a Sanskrit university. From its inception, the need for a Yoga Department in the university was recognized, and it was given a place from the very beginning. The Yoga Department of the university is committed to promoting in-depth study and research in science, philosophy, training, practice, and therapy.</p>
            <p className="mb-4 text-justify">The objective of the Yoga Department is not limited to physical health; rather, it presents Yoga comprehensively by integrating its traditional and scientific perspectives. Here, students are taught classical Yoga to imprint upon them the rich knowledge of tradition, which includes the study of Upanishads, Shrimad Bhagavad Gita, Patanjali Yoga Sutra, Ayurveda, Naturopathy, and texts related to Indian knowledge traditions. Along with this, students are also introduced to modern sciences such as human anatomy and physiology, applied psychology, Indian psychology, research, and investigation. Additionally, adopting the principles of the New Education Policy 2020, the Yoga Department delivers and trains students in employment-oriented curricula.</p>

            <h6 className="mb-3 ">Key Objectives of the University's Yoga Department:</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">**Promotion of Yoga Education** - Developing a classical and scientific understanding of Yoga among students and society, and making Yoga an integral part of lifestyle.</li>
                <li className="list-group-item bg-transparent border-0">**Physical, Mental, and Spiritual Development** - Practicing various limbs of Yoga – Asanas, Pranayama, Dhyana, Yam-Niyama, etc., for the holistic development of students.</li>
                <li className="list-group-item bg-transparent border-0">**Encouraging Research and Innovation** - Promoting research in classical texts related to Yoga, modern science, and medicine, and exploring new dimensions.</li>
                <li className="list-group-item bg-transparent border-0">**Creation of Trained Yoga Experts** - Preparing trained Yoga teachers, Yoga therapists, and instructors as per the needs of society.</li>
                <li className="list-group-item bg-transparent border-0">**Application of Yoga in Health and Disease Prevention** - Spreading awareness for the prevention and treatment of lifestyle-induced diseases through Yoga and organizing special camps/courses.</li>
                <li className="list-group-item bg-transparent border-0">**Preservation of Indian Cultural Heritage** - Preserving and promoting Indian cultural values and traditions through Yoga.</li>
                <li className="list-group-item bg-transparent border-0">**Development of Employment-Oriented Education** - Creating new employment opportunities by presenting Yoga as a vocational subject.</li>
                <li className="list-group-item bg-transparent border-0">**National and International Cooperation** - Establishing cooperation with various educational institutions, health organizations, and international forums in the field of Yoga.</li>
            </ol>
        </div>
    ),
    "courses": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">B.A. (Yoga) – 04 Years</li>
                <li className="list-group-item bg-transparent border-0">M.A. (Yoga) – 02 Years</li>
                <li className="list-group-item bg-transparent border-0">Diploma (Yoga) – 01 Year</li>
            </ul>
        </div>
    ),
    "faculty": (
        <div className="mb-4">
            <h6 className="mb-3">1. Total Faculty – 01</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>Photo</th>
                            <th>Faculty Name</th>
                            <th>Designation</th>
                            <th>Highest Qualification</th>
                            <th>Contact</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. देवेन्द्र सिंह (योग विभाग).jpg")}
                                    alt="Dr. Devendra Singh"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>Dr. Devendra Singh</td>
                            <td>In-Charge, Assistant Professor</td>
                            <td>Ph.D., NET</td>
                            <td>9911872115</td>
                            <td>
                                <a href="mailto:hodyog@mvsu.ac.in">hodyog@mvsu.ac.in</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),

    "timetable": (
        <div>
            <p className="text-muted">Timetable information will be available soon.</p>
        </div>
    ),
    "facilities": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">Systematic Yoga Training:</strong> The department provides students with comprehensive knowledge of classical Yoga, modern Yoga therapy, human physiology, psychology, philosophy, and Yoga practice.</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">Yoga Hall:</strong> A well-equipped Yoga hall is available for students' practice and training.</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">Naturopathy Equipment:</strong> There are arrangements for teaching therapeutic methods by coordinating Yoga and Naturopathy.</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">Compulsory Yoga Camps:</strong> To boost students' confidence and enhance their training skills, regular three-day Yoga camps are organized every session, enabling students to become proficient in conducting Yoga classes.</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">Environment of Sanskrit and Indian Tradition:</strong> As the university is dedicated to the study of Sanskrit and the promotion of Indian culture, Yoga is also taught here with its traditional and classical roots. Students are connected to Yoga not merely as an exercise but with the values of India's rich knowledge and philosophical tradition, so that their personality development also occurs simultaneously.</li>
            </ul>
        </div>
    ),
    "events": (
        <div>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>Speaker/Key Person</th>
                            <th>Program</th>
                            <th>Date</th>
                            <th>Subject</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Dr. Devendra Singh</td>
                            <td>Workshop</td>
                            <td>March 19, 2024</td>
                            <td>Stress Management through Yoga</td>
                        </tr>
                        <tr>
                            <td>Dr. Devendra Singh</td>
                            <td>Workshop</td>
                            <td>June 19, 2023</td>
                            <td>Knowledge of Naturopathy Methods</td>
                        </tr>
                        <tr>
                            <td>Dr. Devendra Singh</td>
                            <td>Workshop</td>
                            <td>March 13-14, 2023</td>
                            <td>Management of various diseases through Naturopathy</td>
                        </tr>
                        <tr>
                            <td>Dr. Devendra Singh</td>
                            <td>Teacher Training Program</td>
                            <td>July 15-21, 2023</td>
                            <td>Intensive Yoga Teacher Training Workshop</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    "researchScholars": (
        <div>
            <p className="text-muted">Currently, no research scholars or Ph.D. students are registered.</p>
        </div>
    ),
    "achievements": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">Students from the Yoga Department's male team secured third place (bronze medal) in the AIU Yogasana competition held at KIIT, Bhubaneswar, from December 23-28, 2024. 415 universities participated in this competition.</li>
                <li className="list-group-item bg-transparent border-0">In the state-level Yogasana competition organized by the Haryana Higher Education Department at Government Post Graduate Women's College, Sector-14, Panchkula, from March 15-17, 2024, the Yoga Department's male team secured first place and the female team secured third place. In the same competition, Bhavishya, a student from the Yoga Department, was selected as the best player.</li>
                <li className="list-group-item bg-transparent border-0">In the 47th Senior National Yoga Sports Championship organized by the Yoga Federation of India (held by Rajasthan Yoga Sports Association from March 25-28, 2023), Gitanshu (B.A. Third Year), a student of the Yoga Department, secured second place in Artistic Pair Yoga, second place in Artistic Yogasana competition, and first place in Flow Yoga Dance in the senior group (18-35 years) male category.</li>
                <li className="list-group-item bg-transparent border-0">In the 48th Senior National Yoga Sports Championship organized by the Yoga Federation of India, held by the West Bengal Association from March 19-23, 2024, Gitanshu, a B.A. Yoga third-year student of Maharshi Valmiki Sanskrit University, Kaithal, Haryana, secured second place in Rhythmic Yoga, second place in Flow Yoga Performance in the senior group (18-35 years) male category, and second place in Yogasana competition in the senior group B (21-25 years) male category.</li>
                <li className="list-group-item bg-transparent border-0">In the 47th Senior National Yoga Sports Championship organized by the Yoga Federation of India, held by Rajasthan Yoga Sports Association from March 25-28, 2023, Seema, a student of Maharshi Valmiki Sanskrit University, Kaithal, Haryana, secured first place in Artistic Pair Yogasana competition in the senior group (18-35 years) female category.</li>
                <li className="list-group-item bg-transparent border-0">Bhavishya, a B.A. Yoga student, secured fifth place in the 38th National Sports Competition held in Almora, Uttarakhand, confirming his place in the Asian Games.</li>
                <li className="list-group-item bg-transparent border-0">Bhavishya, a B.A. Yoga student, won a gold medal by securing first place in the Artistic Solo competition and a bronze medal by securing third place in Traditional at the 49th Senior National Yoga Federation of India competition held in Kerala.</li>
                <li className="list-group-item bg-transparent border-0">So far, approximately 315 Yoga camps have been organized by the Yoga Department of the university.</li>
            </ul>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>S. No.</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>Shri Sitaram</td>
                            <td>Clerk (HKRN)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    "contact": (
        <div>
            <p>Contact details are not available.</p>
        </div>
    )
};

export default function DepartmentYoga_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about"); // Set initial content to "About" (Introduction)

    // Helper to find the display name of the active section
    const getActiveSectionName = () => {
        const activeDept = departments.find(dept => dept.id === activeContentId);
        return activeDept ? activeDept.name : "Yoga Department Section"; // Default if ID not found
    };

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        // Hide sidebar on click for small screens
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
                aria-label="Toggle Menu"
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">Yoga Department</h5>
                <nav className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded small cursor-pointer transition-colors ${activeContentId === dept.id ? "bg-primary text-white shadow-sm" : "bg-light text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </nav>
            </aside>

            {/* Main Content Area */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {/* Dynamic Header for the current section */}
                <h4 className="mb-3 text-primary text-center">{getActiveSectionName()}</h4>
                {/* Render content based on activeContentId */}
                {departmentContent[activeContentId] || <p className="text-muted">Please select a section.</p>}
            </main>

            {/* Inline CSS for transition effect and hover effect */}
            <style jsx>{`
                .transition-colors {
                    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-effect:hover {
                    background-color: #e2e6ea !important; /* Lighter gray on hover for inactive items */
                    color: #000 !important;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
}